import ButtonT from '@components/tailwind-components/Button/ButtonT';
import type { InvalidDataSourceContent } from '@conversed/rest/src/contracts/data-sources/data-sources.dto';
import { useModal } from '@hooks/modal/useModal';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import InvalidContentDisplay from './InvalidContentDisplay';

export const InvalidDataSourceContentModal: React.FC<
  InvalidDataSourceContent
> = (data) => {
  const { t } = useTranslation();
  const { hideModal } = useModal();

  return (
    <form className='tailwind-modal-form flex-1 min-h-[150px] max-h-[600px]'>
      <div className='tailwind-modal-body flex flex-col gap-3 h-inherit whitespace-pre-wrap word-break-style rounded-lg overflow-hidden px-0 mx-2'>
        <div className='h-full flex flex-col bg-gray-100 overflow-auto rounded-lg'>
          {Object.entries(data).map(
            ([key, content]) =>
              content.length > 0 && (
                <div key={key}>
                  <div className='flex py-1 px-3 bg-blue-periwinkle text-white text-sm font-normal'>
                    {t(`data-sources.invalid-data-source-content.${key}`)}
                  </div>
                  <InvalidContentDisplay column={key} content={content} />
                </div>
              ),
          )}
        </div>
      </div>
      <div className='tailwind-modal-footer justify-between'>
        <div className='flex font-normal text-xs text-red-base whitespace-pre-wrap leading-[normal]'>
          {t('data-sources.invalid-data-source-content.modal-description')}
        </div>
        <ButtonT
          onClick={hideModal}
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'>
          {t('general.buttons.cancel')}
        </ButtonT>
      </div>
    </form>
  );
};

export default InvalidDataSourceContentModal;
